// extracted by mini-css-extract-plugin
export default {"pinkred":"#f8395a","blue":"#24355a","lightgrey":"#f7f8f8","grey":"#bdb9b9","darkgrey":"#969393"};